import './Learn.scss';
import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Fieldset } from 'primereact/fieldset';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { OverlayPanel } from 'primereact/overlaypanel';


const LABEL_LIST = [
  {label: 'Label A', value: '1'},
  {label: 'Label B', value: '2'},
  {label: 'Label C', value: '3'},
  {label: 'Label D', value: '4'},
  {label: 'Label E', value: '5'},
  {label: 'Label F', value: '6'},
  {label: 'Label G', value: '7'},
  {label: 'Label H', value: '8'},
];
const SENSOR_LIST = [
  {label: 'Sensor 1', value: '1'},
  {label: 'Sensor 2', value: '2'},
  {label: 'Sensor 3', value: '3'},
  {label: 'Sensor 4', value: '4'},
  {label: 'Sensor 5', value: '5'},
  {label: 'Sensor 6', value: '6'},
  {label: 'Sensor 7', value: '7'},
  {label: 'Sensor 8', value: '8'},
];


class Learn extends React.Component {
  constructor() {
    super();
    this.state = {
      sensors1: ['1', '2'],
      sensors2: ['1', '3'],
      sensors3: ['8'],
    };
  }

  render() {
    return (
      <div className='Learn'>
        <div className='section'>
          <div className='subtitle'>Learning Panel</div>
          <div className='text'>
            Create, deploy, and analyze machine learning models powered by your data.
          </div>
        </div>
        <div className='section'>
          <div className='left-right-container'>
            <div className='left'>
              <Dropdown
                  placeholder='Activity classifier'
                  onChange={e => null}
                  options={[
                      {label: 'Activity classifier', value: 'A'},
                      {label: 'Respiration model', value: 'B'},
                      {label: 'Sneeze detector', value: 'C'},
                      {label: 'Afib detector', value: 'D'},
                      {label: 'Alerts', value: 'E'},
                  ]} />
            </div>
            <div className='right'>
              <Button label='New' icon='pi pi-plus' />
            </div>
          </div>
          <Fieldset legend='Activity classifier'>
            <div className='column-container'>
              <div className='column-1'>
                Overview
              </div>
              <div className='column-2'>
                <div>
                  Status: <strong>Ready</strong>
                </div>
                <div>
                  Performance: <strong>86%</strong>
                  &nbsp;&nbsp;
                  <span className='why'>
                    (<span className='whyLink'
                        onMouseOver={e => this.op.toggle(e)}
                        onMouseOut={e => this.op.toggle(e)}>
                      why?
                    </span>)
                  </span>
                  <OverlayPanel ref={el => this.op = el}>
                    <div className='column-container'>
                      <div className='column-1'>
                        Labels<br />Iterations<br />Test Cases<br />False positives<br />False negatives<br />Benchmark score
                      </div>
                      <div className='column-2'><strong>
                        1192<br />55<br />241<br />19<br />6<br />86%
                      </strong></div>
                    </div>
                  </OverlayPanel>
                </div>
              </div>
            </div>
            <div className='column-container'>
              <div className='column-1'>
                Inputs
              </div>
              <div className='column-2'>
                <div>
                  <Dropdown placeholder='Label A' options={LABEL_LIST} />
                  <MultiSelect value={this.state.sensors1} options={SENSOR_LIST} onChange={(e) => this.setState({sensors1: e.value})} filter={true} />
                  <i className='pi pi-minus-circle' />
                </div>
                <div>
                  <Dropdown placeholder='Label B' options={LABEL_LIST} />
                  <MultiSelect value={this.state.sensors2} options={SENSOR_LIST} onChange={(e) => this.setState({sensors2: e.value})} filter={true} />
                  <i className='pi pi-minus-circle' />
                </div>
                <div>
                  <Button className='' label='Add data source' />
                </div>
              </div>
            </div>
            <div className='column-container'>
              <div className='column-1'>
                Outputs
              </div>
              <div className='column-2'>
                <div>
                  <Dropdown placeholder='Label H' options={LABEL_LIST} />
                  <MultiSelect value={this.state.sensors3} options={SENSOR_LIST} onChange={(e) => this.setState({sensors3: e.value})} filter={true} />
                  <i className='pi pi-minus-circle' />
                </div>
                <div>
                  <Button className='' label='Add output' />
                </div>
              </div>
            </div>
            <div className='column-container'>
              <div className='column-1'>
                Time range
              </div>
              <div className='column-2'>
                <div>
                  <Calendar value={this.state.date} onChange={(e) => this.setState({date: e.value})}
                      showIcon={true}
                      selectionMode='range'
                      />
                </div>
              </div>
            </div>
            <div className='column-container'>
              <div className='column-1'>
                Advanced parameters
              </div>
              <div className='column-2'>
                <Button
                    label='Show advanced parameters'
                    icon='pi pi-plus'
                    className='p-button-secondary' />
              </div>
            </div>
            <div className='left-right-container line-top'>
              <div className='left'>
              </div>
              <div className='right button-row'>
                <Button
                    label='Delete'
                    icon='pi pi-trash'
                    className='p-button-secondary' />
                <Button
                    label='Revert'
                    icon='pi pi-replay'
                    className='p-button-secondary' />
                <Button
                    label='Apply'
                    icon='pi pi-save'
                    className='' />
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
    );
  }
}


export default Learn;
